<template>
  <div class="aco-info-box">
    <b-col class="aco-details">
      <b-form>
        <fieldset :disabled="loading">
          <b-row>
            <b-col>
              <b-alert variant="warning" show dismissible>{{ $t('workInProgress') }}!</b-alert>
            </b-col>
          </b-row>
          <b-row class="aco-details-row">
            <b-col>
              <b-row>
                <b-col><h5>{{ $t('reconciliation') }}</h5></b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="aco-details-row">
            <b-col md="10">
              <b-form-textarea id="userIds" v-model="userIds"/>
            </b-col>
            <b-col md="2">
              <b-button class="float-right mt-auto" variant="primary" @click="reconcileUsers()">{{ $t('submit') }}</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-textarea id="unknownUserIds" :v-if="unknownUserIds" v-model="unknownUserIds"/>
            </b-col>
          </b-row>
        </fieldset>
      </b-form>
    </b-col>
  </div>
</template>

<script>
  import ReconciliationService from '../../services/ReconciliationService'

  export default {
    name: 'Reconciliation',
    data () {
      return {
        loading: false,
        userIds: '',
        unknownUserIds: undefined
      }
    },
    methods: {
      reconcileUsersFields () {
        return [
          { type: 'textarea', width: 12, name: 'userIds', displayName: this.$t('userIds'), required: true, autofocus: true },
        ]
      },
      reconcileUsers () {
        ReconciliationService.reconcileUsers(this.userIds)
          .then(data => {
            this.unknownUserIds = data
          })
      }
    },
    i18n: {
      messages: {
        en: {
          'workInProgress': 'Work in progress'
        },
        nb: {
          'workInProgress': 'Under arbeid'
        }
      }
    }
  }
</script>